module.exports = __webpack_public_path__ + "img/hand-cursor.dd71c80e.png";